
(function() {
  var result = { translations: { "sv": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "\xC5tg\xE4rder" }, "tag": { "remove": "Ta bort tagg" }, "Select": { "noResults": "Inga resultat hittades", "searchPlaceholder": "S\xF6k...", "clearSelections": "Rensa val" }, "ErrorMessage": { "error": { "title": "Allt \xE4r inte f\xF6rlorat." }, "notFound": { "title": "Alla som vandrar har inte g\xE5tt vilse." }, "badRequest": { "title": "Ett problem uppstod n\xE4r denna sida skulle laddas." }, "expired": { "title": "F\xF6rl\xE5t." }, "sessionId": { "prefix": "Sessions-ID: " } }, "ProgressSteps": { "completedStep": "Slutf\xF6rt steg", "incompleteStep": "Ej slutf\xF6rt steg" }, "Paginator": { "label": "Sidnumrering", "pageNumber": { "currentIndicator": "Du \xE4r f\xF6r n\xE4rvarande p\xE5", "description": "Sida" }, "firstPage": { "label": "F\xF6rsta", "description": "F\xF6rsta sidan" }, "previousPage": { "label": "F\xF6reg\xE5ende", "description": "F\xF6reg\xE5ende sida" }, "nextPage": { "label": "N\xE4sta", "description": "N\xE4sta sida" }, "lastPage": { "label": "Sista", "description": "Sista sidan" } }, "Datagrid": { "noData": { "Title": "Ingen data tillg\xE4nglig", "Description": "Det finns inga tillg\xE4ngliga data att visa." }, "noResults": { "Title": "Inga resultat hittades", "Description": "Prova att justera din s\xF6kning och dina filter f\xF6r att hitta det du letar efter.", "ClearActionLabel": "Rensa s\xF6kning och filter" }, "toolbar": { "selectedRows": { "one": "{{count}} vald rad", "other": "{{count}} valda rader", "clearSelection": "Rensa val", "selectAll": "V\xE4lj alla {{totalRows}} rader" }, "search": { "placeholder": "S\xF6k", "label": "S\xF6k", "clearSearch": "Rensa s\xF6kning" } }, "pagination": { "visibleRows": "{{visibleRows}} av {{totalRows}} resultat", "itemsPerPage": "Artiklar per sida", "countPerPage": { "one": "{{count}} per sida", "other": "{{count}} per sida" } }, "SkeletonGrid": { "loading": "Laddar" }, "DataGridColumnManagementPanel": { "description": "V\xE4lj vilka egenskaper som ska visas som kolumner. Flytta sedan egenskaperna upp\xE5t eller ned\xE5t, eller dra och sl\xE4pp, f\xF6r att \xE4ndra ordningen de ska visas i.", "removeAllColumns": "Ta bort alla kolumner", "update": "Uppdatera", "cancel": "Avbryt", "edit": "Redigera kolumner" } } }, "ui": { "UIAbstractPageSection": { "page": "Sidval" }, "UICarousel": { "current": "Visar vara {{currentStepDisplayNumber}} av {{totalSteps}}", "prev": "Tidigare", "next": "N\xE4sta", "tip": "Anv\xE4nd piltangenterna f\xF6r att se andra alternativ" }, "UIColorSwatch": { "label": "F\xE4rgv\xE4ljare {{value}}", "noColorLabel": "F\xE4rgv\xE4ljare, ingen f\xE4rg har valts." }, "UIButtonCollapser": { "dropdownLabel": "\xC5tg\xE4rder" }, "UIErrorMessage": { "error": { "title": "Allt \xE4r inte f\xF6rlorat." }, "notFound": { "title": "Alla som vandrar har inte g\xE5tt vilse." }, "badRequest": { "title": "Ett problem uppstod n\xE4r denna sida skulle laddas." }, "expired": { "title": "F\xF6rl\xE5t." } }, "UIPanelNavigator": { "backButton": "G\xE5 till f\xF6reg\xE5ende sk\xE4rm" }, "UILoadingSpinner": { "busyText": "Laddar", "completedText": "Laddad" }, "UISideNav": { "navigationLandmark": "Sekund\xE4r" }, "UISortTH": { "ascendingSort": "Stigande sortering. Tryck f\xF6r att sortera fallande.", "descendingSort": "Fallande sortering. Tryck f\xF6r att sortera stigande.", "pressToSort": "Tryck f\xF6r att sortera." }, "autosizedTextInput": { "charactersRemaining": "{{value}} tecken kvar" }, "time": { "today": "Idag vid {{time}}", "yesterday": "Ig\xE5r vid {{time}}", "datetime": "{{date}} kl. {{time}}" }, "progress": { "percentComplete": "{{percent}} slutf\xF6rt" }, "datePicker": { "dateSelected": "{{date}} har valts.", "noDateSelected": "Inget datum har valts.", "dateBelowMin": "Du m\xE5ste v\xE4lja ett senare datum", "dateAboveMax": "Du m\xE5ste v\xE4lja ett tidigare datum", "invalidDate": "Ogiltigt datum", "today": "Idag", "clear": "Rensa", "placeholder": { "month": "MM", "day": "DD", "year": "\xC5\xC5\xC5\xC5" }, "nextMonth": "N\xE4sta m\xE5nad", "prevMonth": "F\xF6reg\xE5ende m\xE5nad" }, "dateRange": { "startDate": "Startdatum", "endDate": "Slutdatum", "endDateBeforeStartDate": "Slutdatumet m\xE5ste vara efter startdatumet.", "startDateAfterEndDate": "Startdatumet m\xE5ste vara innan slutdatumet.", "to": "till" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "... och {{count}} till.", "loadMore": "Ladda mer" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "L\xE4gg till" }, "UIAvatarHoverlay": { "text": "Byt foto" }, "UIChangeArrow": { "decrease": "Minskning av", "increase": "\xD6kning av" }, "UICopyInput": { "label": "Text", "title": "Kopiera till urklipp", "tooltipCopied": "Kopierad" }, "UIConfirm": { "defaultConfirm": "Ja", "defaultReject": "Nej" }, "UICloseButton": { "label": "St\xE4ng" }, "UIDateRangePicker": { "rangeType": { "ALL": "Hela tiden", "THIS_DAY": "Idag", "LAST_DAY": "Ig\xE5r", "THIS_WEEK": "Denna vecka", "LAST_WEEK": "Senaste veckan", "THIS_MONTH": "Denna m\xE5nad", "LAST_MONTH": "F\xF6rra m\xE5naden", "LAST_THIRTY_DAYS": "Senaste 30 dagarna", "LAST_THREE_MONTHS": "Senaste 3 m\xE5naderna", "THIS_QUARTER": "Detta kvartal", "LAST_QUARTER": "Senaste kvartalet", "THIS_YEAR": "Detta \xE5r", "LAST_YEAR": "F\xF6rra \xE5ret", "CUSTOM": "Anpassad tidsperiod" } }, "UIDropdownSelect": { "placeholder": "Inget v\xE4rde har valts" }, "UIEditableControls": { "cancel": "Avbryt", "save": "Spara" }, "UIExpandableText": { "collapseButtonText": "Se mindre", "expandButtonText": "Visa mer" }, "UIFileInput": { "defaultChangeLabel": "\xC4ndra fil", "defaultSelectLabel": "V\xE4lj fil" }, "UIIconRating": { "ariaValueText": "{{value}} av {{maxValue}}" }, "UILink": { "externalTitle": "L\xE4nk \xF6ppnas i ett nytt f\xF6nster" }, "UILoading": { "title": "Laddar \u2026" }, "UILockBadge": { "title": "Den h\xE4r funktionen \xE4r l\xE5st" }, "UIPaginator": { "label": "Sidnumrering", "pageNumber": { "currentIndicator": "Du \xE4r f\xF6r n\xE4rvarande p\xE5", "description": "Sida" }, "firstPage": { "label": "F\xF6rsta", "description": "F\xF6rsta sidan" }, "previousPage": { "label": "F\xF6reg\xE5ende", "description": "F\xF6reg\xE5ende sida" }, "nextPage": { "label": "N\xE4sta", "description": "N\xE4sta sida" }, "lastPage": { "label": "Sista", "description": "Sista sidan" } }, "UIPreviousButton": { "label": "Tidigare" }, "UINextButton": { "label": "N\xE4sta" }, "UINumberRating": { "lowRangeLabel": "Jag h\xE5ller inte alls med", "highRangeLabel": "Jag h\xE5ller helt med" }, "UISearchableSelectInput": { "placeholder": "S\xF6k" }, "UISearchInput": { "placeholder": "S\xF6k", "minimumSearchMessage": { "one": "Skriv 1 tecken till", "other": "Skriv {{count}} tecken till" }, "clearButton": "Rensa inmatning" }, "UISelect": { "allOptionsSelected": "Alla alternativ \xE4r valda", "createOption": "Skapa alternativ \"{{label}}\"", "plusMore": "+ {{count}} till", "andMore": "... och {{count}} till.", "loadMore": "Ladda mer", "noResults": "Inga resultat hittades", "placeholder": "S\xF6k", "typeToSearch": "Ange f\xF6r att s\xF6ka" }, "UITable": { "selectableTableRow": { "toggleSelection": "V\xE4xla val av rad" } }, "UITabs": { "moreDropdownLabel": "Fler" }, "UITeaseNotification": { "optionsButtonTooltipText": "Visa alternativ" }, "UITimePicker": { "placeholder": "V\xE4lj en tid" }, "UIToggle": { "checkedLabel": "P\xC5", "uncheckedLabel": "AV" }, "UITypeahead": { "noMatchesFound": "Inga resultat hittades", "noOptions": "Ingen" }, "UIWizard": { "back": "Tillbaka", "cancel": "Avbryt", "done": "Klart", "next": "N\xE4sta", "stepCount": "Steg {{stepNumber}} av {{stepCount}}" }, "XSSTooltip": { "explanation": "Den h\xE4r l\xE4nken har inaktiverats f\xF6r din s\xE4kerhet." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "sv": "static-1.4668"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4668",
    "ar-eg": "static-1.4668",
    "bg": "static-1.4668",
    "bn": "static-1.4668",
    "ca-es": "static-1.4668",
    "cs": "static-1.4668",
    "da": "static-1.4668",
    "de": "static-1.4668",
    "el": "static-1.4668",
    "en-gb": "static-1.4668",
    "en": "static-1.4668",
    "es-mx": "static-1.4668",
    "es": "static-1.4668",
    "et": "static-1.4668",
    "fi": "static-1.4668",
    "fr-ca": "static-1.4668",
    "fr": "static-1.4668",
    "he-il": "static-1.4668",
    "hi": "static-1.4668",
    "hr": "static-1.4668",
    "hu": "static-1.4668",
    "id": "static-1.4668",
    "it": "static-1.4668",
    "ja": "static-1.4668",
    "ko": "static-1.4668",
    "lt": "static-1.4668",
    "ms": "static-1.4668",
    "nl": "static-1.4668",
    "no": "static-1.4668",
    "pl": "static-1.4668",
    "pt-br": "static-1.4668",
    "pt-pt": "static-1.4668",
    "ro": "static-1.4668",
    "ru": "static-1.4668",
    "sk": "static-1.4668",
    "sl": "static-1.4668",
    "sv": "static-1.4668",
    "th": "static-1.4668",
    "tl": "static-1.4668",
    "tr": "static-1.4668",
    "uk": "static-1.4668",
    "vi": "static-1.4668",
    "zh-cn": "static-1.4668",
    "zh-hk": "static-1.4668",
    "zh-tw": "static-1.4668"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:sv', {version: 'static-1.4668'}); }
})();



(function() {
  var result = { translations: { "sv": { "placeholder": "platsh\xE5llare" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "sv": "static-3.6266"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6266",
    "ar-eg": "static-3.6266",
    "bg": "static-3.6266",
    "bn": "static-3.6266",
    "ca-es": "static-3.6266",
    "cs": "static-3.6266",
    "da": "static-3.6266",
    "de": "static-3.6266",
    "el": "static-3.6266",
    "en-gb": "static-3.6266",
    "en": "static-3.6266",
    "es-mx": "static-3.6266",
    "es": "static-3.6266",
    "et": "static-3.6266",
    "fi": "static-3.6266",
    "fr-ca": "static-3.6266",
    "fr": "static-3.6266",
    "he-il": "static-3.6266",
    "hi": "static-3.6266",
    "hr": "static-3.6266",
    "hu": "static-3.6266",
    "id": "static-3.6266",
    "it": "static-3.6266",
    "ja": "static-3.6266",
    "ko": "static-3.6266",
    "lt": "static-3.6266",
    "ms": "static-3.6266",
    "nl": "static-3.6266",
    "no": "static-3.6266",
    "pl": "static-3.6266",
    "pt-br": "static-3.6266",
    "pt-pt": "static-3.6266",
    "ro": "static-3.6266",
    "ru": "static-3.6266",
    "sk": "static-3.6266",
    "sl": "static-3.6266",
    "sv": "static-3.6266",
    "th": "static-3.6266",
    "tl": "static-3.6266",
    "tr": "static-3.6266",
    "uk": "static-3.6266",
    "vi": "static-3.6266",
    "zh-cn": "static-3.6266",
    "zh-hk": "static-3.6266",
    "zh-tw": "static-3.6266"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:sv', {version: 'static-3.6266'}); }
})();



(function() {
  var result = { translations: { "sv": { "app": { "htmlTitle": "Viral l\xE4nk-UI", "welcomeHome": "V\xE4lkommen hem {{ firstName }}!", "yourAppIsReady": "Din app \xE4r klar", "aSecondPage": "En andra sida f\xF6r att f\xE5 plats med mer inneh\xE5ll", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Fyll i denna tomma sida med ", createElement( options, "Link", props.linkProps, "komponenter" ), " i ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Skapa dina egna gratisformul\xE4r</strong> f\xF6r att generera potentiella kunder fr\xE5n din webbplats." }, "liveChat": { "linkCta": "<strong>L\xE4gg till livechatt.</strong> Kommunicera med bes\xF6kare. Gratis.", "ariaLabel": "L\xE4gg till livechatt. Kommunicera med bes\xF6kare. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] L\xE4gg till livechatt.</strong> Kommunicera med bes\xF6kare. Gratis.", "ariaLabel": "[Int] L\xE4gg till livechatt. Kommunicera med bes\xF6kare. Gratis." }, "meetings": { "linkCta": "<strong>Skapa din kostnadsfria m\xF6tesbokningssida</strong> f\xF6r att schemal\xE4gga m\xF6ten snabbare." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "sv": "static-1.3877"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3877",
    "ar-eg": "static-1.3877",
    "bg": "static-1.3877",
    "bn": "static-1.3877",
    "ca-es": "static-1.3877",
    "cs": "static-1.3877",
    "da": "static-1.3877",
    "de": "static-1.3877",
    "el": "static-1.3877",
    "en-gb": "static-1.3877",
    "en": "static-1.3877",
    "es-mx": "static-1.3877",
    "es": "static-1.3877",
    "et": "static-1.3877",
    "fi": "static-1.3877",
    "fr-ca": "static-1.3877",
    "fr": "static-1.3877",
    "he-il": "static-1.3877",
    "hi": "static-1.3877",
    "hr": "static-1.3877",
    "hu": "static-1.3877",
    "id": "static-1.3877",
    "it": "static-1.3877",
    "ja": "static-1.3877",
    "ko": "static-1.3877",
    "lt": "static-1.3877",
    "ms": "static-1.3877",
    "nl": "static-1.3877",
    "no": "static-1.3877",
    "pl": "static-1.3877",
    "pt-br": "static-1.3877",
    "pt-pt": "static-1.3877",
    "ro": "static-1.3877",
    "ru": "static-1.3877",
    "sk": "static-1.3877",
    "sl": "static-1.3877",
    "sv": "static-1.3877",
    "th": "static-1.3877",
    "tl": "static-1.3877",
    "tr": "static-1.3877",
    "uk": "static-1.3877",
    "vi": "static-1.3877",
    "zh-cn": "static-1.3877",
    "zh-hk": "static-1.3877",
    "zh-tw": "static-1.3877"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:sv', {version: 'static-1.3877'}); }
})();


